// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".leading-event-header{line-height:1.08}.gradient-overlay{background:linear-gradient(0deg,#fff,transparent);bottom:0;bottom:0;height:2.5rem;left:0;left:0;pointer-events:none;position:absolute;right:0;right:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
